import { makeAutoObservable } from 'mobx';
import ModalDelegate from 'store/general/modalDelegate';

import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { ProductLineAttr } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { PortfolioToCartItem } from '../types';
import IProposalPageStore from '../iProposalPageStore';

export default class ProductLineDelegate<PageStore extends IProposalPageStore> {
  private pageStore: PageStore;
  private _productLineId: ProductLineId | null;
  private _portfolioToCartItems: PortfolioToCartItem[] = [];
  private _productLineAttributes: ProductLineAttr[] = [];

  public createPortfolioModalDelegate = new ModalDelegate();

  public canShowCreatePortfolioModal(): boolean {
    if (!this._productLineId) {
      throw new Error('No valid product line id provided!');
    }
    const domainProductLine = this.pageStore.getDomainProductLine(this._productLineId);
    if (!domainProductLine) {
      return false;
    }
    const userRoles = this.pageStore.userRoles;

    if (!domainProductLine.dynamicPortfolios.creationAvailable) {
      return false;
    }

    const isValidByRole = domainProductLine.dynamicPortfolios.creationRoles.some((domainRole) =>
      userRoles.some((userRole) => domainRole === userRole),
    );

    return isValidByRole && this._portfolioToCartItems.length > 1;
  }

  public get portfolioToCartItems(): PortfolioToCartItem[] {
    return this._portfolioToCartItems;
  }

  public get productLineId(): ProductLineId {
    if (!this._productLineId) {
      throw new Error('ProductLineDelegate initiated without product line id!');
    } else {
      return this._productLineId;
    }
  }

  public get productLineAttributes(): ProductLineAttr[] {
    return this._productLineAttributes;
  }

  public get isDontProvide(): boolean {
    return this.pageStore.initialStore.isProductLineDontProvide(this.productLineId);
  }

  constructor(pageStore: PageStore, productLineId: ProductLineId | null) {
    this.pageStore = pageStore;
    this._productLineId = productLineId;
    if (this._productLineId) {
      const result = this.pageStore.getPortfolioByProductLine(this._productLineId);

      this._portfolioToCartItems = result.portfolioToCartItems
        .slice()
        .sort((firstItem, secondItem) =>
          firstItem.portfolio.products.length > secondItem.portfolio.products.length ? -1 : +1,
        );
      this._productLineAttributes = result.productLineAttributes;
    }

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
